import { render, staticRenderFns } from "./EditorComponent.vue?vue&type=template&id=681265f0&scoped=true&"
import script from "./EditorComponent.vue?vue&type=script&lang=js&"
export * from "./EditorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681265f0",
  null
  
)

export default component.exports